import { UserAPI } from "@/API/User"
import { userActions } from "@/redux/slice/userSlice"
import { appActions } from "@/redux/slice/appSlice"
import { AppDispatch } from "@/redux"
import { formattedUserMessage, UserMessage } from "@/constants/users/user"
import { showNotification } from "./notificationService"
import {
  ChangePasswordRequestBody,
  InviteUserRequestBody,
  UpdatePersonalDetailsRequestBody,
  UpdateUserRoleRequestBody
} from "@/types/users"

export const getUser = (token: string) => async (dispatch: AppDispatch) => {
  dispatch(appActions.setLoading(true))
  const resp = await UserAPI.getCurrentUserDetailsByToken(token)
  if (resp.data) {
    dispatch(userActions.setUserDetails(resp.data.user))
  }
  dispatch(appActions.setLoading(false))
  return resp.data
}

export const changePassword = (
  token: string,
  requestBody: ChangePasswordRequestBody
) => async (dispatch: AppDispatch) => {
  dispatch(appActions.setLoading(true))
  const resp = await UserAPI.changePassword(token, requestBody)
  showNotification(
    resp,
    UserMessage.PASSWORD_CHANGE_SUCCESSFUL,
    formattedUserMessage
  )
  dispatch(appActions.setLoading(false))
  return resp
}

export const updatePersonalDetails = (
  token: string,
  requestBody: UpdatePersonalDetailsRequestBody
) => async (dispatch: AppDispatch) => {
  dispatch(appActions.setLoading(true))
  const resp = await UserAPI.updatePersonalDetails(token, requestBody)
  showNotification(
    resp,
    UserMessage.USER_PERSONAL_DETAILS_UPDATED_SUCCESSFULLY,
    formattedUserMessage
  )
  if (resp.data) {
    await dispatch(getUser(token))
  }
  dispatch(appActions.setLoading(false))
  return resp
}

export const getAllUsersInOrganization = (
  token: string
) => async (dispatch: AppDispatch) => {
  dispatch(appActions.setLoading(true))
  const resp = await UserAPI.getAll(token)
  if (resp.data?.users) {
    dispatch(userActions.setUsers(resp.data.users))
  }
  dispatch(appActions.setLoading(false))
  return resp
}

export const getAllInvitedUsersInOrganization = (
  token: string
) => async (dispatch: AppDispatch) => {
  dispatch(appActions.setLoading(true))
  const resp = await UserAPI.getAllInvitedUser(token)
  if (resp.data?.users) {
    dispatch(userActions.setInvitedUsers(resp.data.users))
  }
  dispatch(appActions.setLoading(false))
  return resp
}

export const updateUserInOrganization = (
  token: string,
  userId: string,
  body: UpdateUserRoleRequestBody
) => async (dispatch: AppDispatch) => {
  dispatch(appActions.setLoading(true))
  const resp = await UserAPI.update(token, userId, body)
  showNotification(
    resp,
    UserMessage.USER_ROLE_UPDATED_SUCCESSFULLY,
    formattedUserMessage
  )
  if (resp.data) {
    await dispatch(getAllUsersInOrganization(token))
    await dispatch(getUser(token))
  }
  dispatch(appActions.setLoading(false))
  return resp
}

export const deleteUserFromOrganization = (
  token: string,
  userId: string
) => async (dispatch: AppDispatch) => {
  dispatch(appActions.setLoading(true))
  const resp = await UserAPI.deleteUser(token, userId)
  showNotification(
    resp,
    UserMessage.USER_DELETED_SUCCESSFULLY,
    formattedUserMessage
  )
  if (resp.data) {
    await dispatch(getAllUsersInOrganization(token))
  }
  dispatch(appActions.setLoading(false))
  return resp
}

export const inviteUserToOrganization = (
  token: string,
  body: InviteUserRequestBody
) => async (dispatch: AppDispatch) => {
  dispatch(appActions.setLoading(true))
  const resp = await UserAPI.inviteUser(token, body)
  showNotification(
    resp,
    UserMessage.USER_INVITED_TO_ORGANIZATION,
    formattedUserMessage
  )
  if (resp.data) {
    await dispatch(getAllInvitedUsersInOrganization(token))
  }
  dispatch(appActions.setLoading(false))
  return resp
}

export const revokeInvite = (
  token: string,
  userInviteId: string
) => async (dispatch: AppDispatch) => {
  dispatch(appActions.setLoading(true))
  const resp = await UserAPI.revokeInvite(token, userInviteId)
  showNotification(
    resp,
    UserMessage.USER_INVITE_REVOKED,
    formattedUserMessage
  )
  if (resp.data) {
    await dispatch(getAllInvitedUsersInOrganization(token))
  }
  dispatch(appActions.setLoading(false))
  return resp
}
